import { createSlice } from '@reduxjs/toolkit';

import axios from 'utils/axios';
import { dispatch } from '../index';
import project from './project';

const initialState = {
    error: null,
    projectName: "",
    campaigns: [],
    count: 0,
    page: 1,
    pageDisplay: 12,
    modeFilter: 'all',
    statusFilter: null,
    sorting: 'lastModifiedDate',
    ordering: 'desc'
};

const slice = createSlice({
    name: 'workplace',
    initialState,
    reducers: {
        hasError(state, action) {
            if(action.payload.response ? (action.payload.response.status == 401) : (action.payload.status == 401)) {
                window.location.pathname = 'login'
            } else {
                state.error = action.payload;
            }
        },
        getCampaignsInit(state, action) {
            state.projectName = action.payload.projectName;
            state.campaigns = action.payload.campaignList;
            state.count = action.payload.total;
        },
        campaignListAppend(state, action) {
            state.campaigns = [...state.campaigns, ...action.payload.campaignList];
        },
        updateMode(state, action) {
            state.modeFilter = action.payload;
        },
        updateStatus(state, action) {
            state.statusFilter = action.payload;
        },
        updateSorting(state, action) {
            state.sorting = action.payload;
        },
        updateSortingOrder(state, action) {
            state.ordering = action.payload;
        },
        updatePage(state, action) {
            state.page = action.payload;
        },
        clearCampaignInfo(state) {
            state.campaigns = [];
            state.count = 0;
        }
    }
});

export default slice.reducer;

export function updateModeFilter(data) {
    return () => {
        dispatch(slice.actions.updateMode(data));
    };
}

export function updateStatusFilter(data) {
    return () => {
        dispatch(slice.actions.updateStatus(data));
    };
}

export function updateSortingField(data) {
    return () => {
        dispatch(slice.actions.updateSorting(data));
    };
}

export function updateOrdering(data) {
    return () => {
        dispatch(slice.actions.updateSortingOrder(data));
    };
}

export function updateCurrentPage(data) {
    return () => {
        dispatch(slice.actions.updatePage(data));
    };
}

export function getCampaigns(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/list', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (data.currentPage === 1) {
                dispatch(slice.actions.getCampaignsInit(response.data));
            } else {
                dispatch(slice.actions.campaignListAppend(response.data));
            }
            
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function updateCampaignStatus(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/update', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function clearCampaignInfo() {
    return () => {
        dispatch(slice.actions.clearCampaignInfo());
    };
};
